// Generated by genversion.
export const version = '10.1.1';
//# sourceMappingURL=version.js.map